function DeleteUser() {
  return <h3 style={{ textAlign: "center" }}>Delete user</h3>;
}

export default DeleteUser;
